const actionTypeIdentifier = 'FD754ED5-F1F0-42E9-AC56-F173FF9FF8FC';

export const resetFileAttachment = `RESET-FILE-ATTACHMENT-${actionTypeIdentifier}`;
export const updateAttachFile = `UPDATE-ATTACH-FILE-${actionTypeIdentifier}`;
export const setDisableAttachBtn = `SET-DISABLE-ATTACH-BUTTON-${actionTypeIdentifier}`;

